export default __webpack_public_path__ + "static/media/style-belgardMegaArbel.7e29fb0b.jpg";